import { FormlyFieldConfig } from '@ngx-formly/core';

export function minLengthValidationMessage(error: any, field: FormlyFieldConfig) {
  return `Sono richiesti almeno ${field.props!.minLength} caratteri`;
}

export function maxLengthValidationMessage(error: any, field: FormlyFieldConfig) {
  return `Questo valore dovrebbe essere inferiore a ${field.props!.maxLength} caratteri`;
}

export function minValidationMessage(error: any, field: FormlyFieldConfig) {
  return `Questo valore dovrebbe essere superiore a ${field.props!.min}`;
}

export function maxValidationMessage(error: any, field: FormlyFieldConfig) {
  return `Questo valore dovrebbe essere inferiore a ${field.props!.max}`;
}
